import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {when} from 'lit/directives/when.js';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';
import store from '../../../store';
import {baseProfileOptions} from '../../lightProfileSectionConfig';

@customElement('page-light-summary')
export class PageLightSummary extends connect(store)(LitElement) {

	static styles = [
		css`

			.content {
				display: block;
			}

			.description {
				margin-top: var(--font-specsheet-print-light);
				max-width: 75%;
			}

			.description p {
				font: var(--font-specsheet-print-light);
				font-size: 2cqw;
				max-width: 75%;
			}

			.numbers {
				background-color: transparent;
				border: 1px solid #000;
				box-shadow: none;
				color: #000;
				display: inline-block;
				font: var(--font-specsheet-print-light);
				font-size: 1cqw;
				padding: 0.5cqw 1cqw;
				text-decoration: none;
			}

			.img-container img {
				aspect-ratio: 2.5 / 1;
				width: 100%;
				object-fit: cover;
				margin-top: 2cqw;
			}
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.translations = state.productData.translations;
		this.profile = state.lightProfile.data.profile;
		this.lightProfile = state.lightProfile.data;
		this.lang = state.status.lang;
		this.status = state.status;
		this.baseProfileOptions = this.baseProfileData(this.lightProfile.project.base);
		this.shortNumberProductModel = state.shortNumber.data.ProductModel ?? '';
		this.shortNumberCircularProfile = state.shortNumber.data.CircularProfile ?? '';
	}

	baseProfileData(id) {
		return baseProfileOptions.find(baseProfileOption => baseProfileOption.id === id);
	}

	render() {
		const s = this.state;
		const label = this.baseProfileOptions ? this.baseProfileOptions.label[this.lang] : '';
		const description = this.baseProfileOptions ? this.baseProfileOptions.description[this.lang] : '';
		this.base = baseProfileOptions.find(base => base.id === this.lightProfile.project.base);
		return html`
			<div slot="content" class="lightProfilePdf">
				<page-header title="${msg('Nature-Centric Lighting')}"
							 intro="${msg('Light in natural rhythm for people, plants and animals')}"
							 labelChoice="summary">
				</page-header>
				<div class="description">
					<p>${description}</p>
					<a href="${this.status.host}${this.status.baseUrl}${this.status.region}/${this.status.lang}/${this.status.family}/sections/${this.status.mode}/${this.status.shortKey}"
					   class="numbers">
						${this.shortNumberCircularProfile}
						${when(this.shortNumberProductModel !== '', () => html`- ${this.shortNumberProductModel}`)}
					</a>
				</div>
				<div class="img-container">
					<img alt="" src="${this.base?.specimg}"/>
				</div>
				<div class="img-container">
					<img alt="" src="${this.base?.specimg2}"/>
				</div>
			</div>
		`;
	}
}
